import { render, staticRenderFns } from "./ApplyRecord.vue?vue&type=template&id=36b2c17e&"
import script from "./ApplyRecord.vue?vue&type=script&lang=js&"
export * from "./ApplyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports